import React, { Component } from "react";
// 接口以及调用接口方法
import { successQry } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// icon
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
// 组件
import PeopleRateBar from "@/pages/displayBoard/peopleRateBar";
import SuccessRateBar from "@/pages/displayBoard/successRateBar";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class PeopleZhuPage extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      param: [],
    };
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    this.setState(
      {
        param: nextProps.param,
      },
      () => {
        // 获取数据
        this.getSuccessRate();
      },
    );
  }

  // 页面加载前获取充电成功率数据
  componentWillMount() {
    this.getSuccessRate();
  }

  // 获取数据
  getSuccessRate() {
    this.props.getSuccessRate(this.state.param);
  }

  render() {
    const content = (
      <div
        className="board-inner"
        style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: 'center !important' }}
      >
        <div className="line-title">各等级工单处理工时</div>
        <div
          className="line-part"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <PeopleRateBar param={this.state.param} />
        </div>
      </div>
    );

    return content;
  }
}

export default injectIntl(PeopleZhuPage);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/peopleZhuPage.js